import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';
import { fontGmarketSans } from '@/styles/themes/variables';

export const Wrapper = styled.section`
  position: relative;
  height: 250px;
  ${DESKTOP} {
    height: 430px;
  }
`;

export const Contents = styled.div`
  margin: 0 auto;
  width: 328px;
  ${DESKTOP} {
    width: 1000px;
  }
`;

export const Logo = styled.div`
  display: inline-block;
  cursor: pointer;
  width: 80px;
  padding-bottom: 24px;
  ${DESKTOP} {
    width: 117px;
    padding-bottom: 48px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  height: 152px;
  padding: 16px 0;
  margin: 0 auto 0 auto;
  ${DESKTOP} {
    padding: 0;
    height: 272px;
  }
`;

export const Title = styled.h1`
  color: #e4e4e4;
  font-weight: 700;
  font-size: 24px;
  font-family: ${fontGmarketSans};
  span {
    color: white;
  }
  ${DESKTOP} {
    font-size: 48px;
  }
`;

export const HeaderImg = styled.div`
  width: 148px;
  ${DESKTOP} {
    width: 265px;
  }
`;

export const ShipImg = styled.div`
  position: absolute;
  z-index: 10;
  width: 148px;
  ${DESKTOP} {
    width: 265px;
  }
`;

export const Confetti = styled(ShipImg)`
  z-index: 0;
  height: 148px;
  ${DESKTOP} {
    height: 265px;
  }
`;

export const SeaImg = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 50px;
  ${DESKTOP} {
    height: 97px;
  }
`;
